// src/store/slices/bannersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constants/apiUrl";

export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (filters, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${apiUrl}/admin/sliders`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addBanner = createAsyncThunk(
  "trainers/addBanner",
  async (bannerData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/sliders`, bannerData, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const deleteBanner = createAsyncThunk(
  "banners/deleteBanner",
async (id , thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state
console.log(id,"idididididididid");

      const response = await axios.delete(`${apiUrl}/admin/sliders/${id}`, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const bannersSlice = createSlice({
  name: "banners",
  initialState: {
    list: [],
status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(addBanner.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(addBanner.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(addBanner.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(deleteBanner.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(deleteBanner.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })

  },
});

export default bannersSlice.reducer;
